import { FC } from 'react';
import { BROKERS } from 'v3/common/constants/index';
import Zebull from './Brokers/Zebull';
import Iifl from './Brokers/Iifl';
import Paytm from './Brokers/Paytm';
import KotakNeo from './Brokers/KotakNeo';
import Sharekhan from './Brokers/Sharekhan';
import PhilipCapital from './Brokers/PhilipCapital';
import Rupeezy from './Brokers/Rupeezy';
import Flattrade from './Brokers/Flattrade';
import DeltaExchange from './Brokers/DeltaExchange';
import CoinDcx from './Brokers/CoinDcx';
import InvestRight from './Brokers/Investright';
import HdfcSky from './Brokers/HdfcSky';
import Upstox from './Brokers/Upstox';
import Fyers from './Brokers/Fyers';
import AngelBroking from './Brokers/AngelBroking';
import Profitmart from './Brokers/Profitmart';
import Finvasia from './Brokers/Finvasia';
import Fivepaisa from './Brokers/Fivepaisa';

type GuideComponentsProps = {
  broker: string | null;
};

const GuideComponents: FC<GuideComponentsProps> = ({ broker }) => {
  switch (broker) {
    case BROKERS.zebull.id:
      return <Zebull />;
    case BROKERS.iifl.id:
      return <Iifl />;
    case BROKERS.invest_right.id:
      return <InvestRight />;
    case BROKERS.hdfcsky.id:
      return <HdfcSky />;
    case BROKERS.paytm.id:
      return <Paytm />;
    case BROKERS.kotak_neo.id:
      return <KotakNeo />;
    case BROKERS.sharekhan.id:
      return <Sharekhan />;
    case BROKERS.philip_capital.id:
      return <PhilipCapital />;
    case BROKERS.rupeezy.id:
      return <Rupeezy />;
    case BROKERS.upstox.id:
      return <Upstox />;
    case BROKERS.flattrade.id:
      return <Flattrade />;
    case BROKERS.delta_exchange.id:
      return <DeltaExchange />;
    case BROKERS.coin_dcx.id:
      return <CoinDcx />;
    case BROKERS.fyers.id:
      return <Fyers />;
    case BROKERS.angel_broking.id:
      return <AngelBroking />;
    case BROKERS.profitmart.id:
      return <Profitmart />;
    case BROKERS.finvasia.id:
      return <Finvasia />;
    case BROKERS.fivepaisa.id:
      return <Fivepaisa />;
    default:
      return <></>;
  }
};

export default GuideComponents;
